
var ajax = $.ajax;
const url_req = "./php/request.php";
const ocr_url = 'ocr.promotraffic.pl'

function updateAuth() {

	let auth = BX24.getAuth();
	return {
		domain: auth.domain,
		token: auth.access_token
	};
}


export function getDataCompany(page) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getDataCompany",
			domain: auth.domain,
			auth: auth.token,
			page
		},
	});
}

export function getfile(page, params, sorter) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getfile",
			domain: auth.domain,
			auth: auth.token,
			page,
			params,
			sorter
		},
	});
}

export function getDiskFile(page, params, sorter) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getDiskFile",
			domain: auth.domain,
			auth: auth.token,
			page,
			params,
			sorter
		},
	});
}

export function getDiskFileFromMail(page, params, sorter) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getDiskFileFromMail",
			domain: auth.domain,
			auth: auth.token,
			page,
			params,
			sorter
		},
	});
}

export function getFileInfoFirstStage(flagFirstStage, fileID) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getFileInfoFirstStage",
			domain: auth.domain,
			auth: auth.token,
			first_stage: flagFirstStage,
			id_file: fileID,
		},
	});
}


export function getOpenSettings() {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getOpenSettings",
			domain: auth.domain,
			auth: auth.token
		},
	});
}

function FetchBody(body) {
	var formData = new FormData();
	let auth = updateAuth();
	formData.append('domain', auth.domain);
	formData.append('auth', auth.token);
	FormDataRecursion(formData, body);
	return formData;
}

function FormDataRecursion(formData, dataVal, dataKey, dataSubKey) {
	if (typeof dataVal != "object") {
		if (dataSubKey != undefined) {
			return formData.append(dataSubKey + "[" + dataKey + "]", dataVal);
		}
		return formData.append(dataKey, dataVal);
	} else {
		for (let [key, value] of Object.entries(dataVal)) {
			FormDataRecursion(formData, value, key, dataKey);
		}
	}
}

export function getLang() {
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getlang",
			lang: BX24.getLang()
		}
	});
}

export function getLangNEW() {

	let lang = BX24.getLang();
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({ run: 'getlang', lang: lang, })
	});
}


export function getSettings() {
	
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "getsettings",
			part_data: 0,
			companyType:BX24.appOption.get('companyType') || false
		})
	})
}

export function getExcel({ files_for_export, columns }) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "exporttoxxcel",
			files_for_export,
			columns,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function getXml({ files_for_export, columns }) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "exportToXml",
			files_for_export,
			columns,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function getExcelSales(files_for_export, columns) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "exportsales",
			files_for_export,
			columns,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export async function getInvoices() {
	return await fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "getinvoices",
			part_data: 0
		})
	})
}

export function editClose(mainid) {
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "editclose",
			mainid: mainid
		})
	})
}



export function saveSettings(params) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "savesettings",
			words: params.words,
			SPECJALIZACJA: params.SPECJALIZACJA,
			bookkeeping: params.bookkeeping,
			MPK: params.MPK,
			CostTypes: params.CostTypes,
			BankAccount: params.BankAccount,
			api_ocr_token: params.api_ocr_token,
			responsibleExport: params.responsibleExport,
			folder: params.folder,
			companyType: params.companyType,
			responsible: params.responsible,
			nip: params.nip,
			licenseKey: params.licenseKey,
			termin: params.terminPlat,
			mail_folder: params.mail_folder,
			mail_user: params.mail_user,
			responsibleSpredz: params.responsibleSpredz,
			mediaAssigned: params.mediaAssigned,
			mediaResponsible: params.mediaResponsible,
			templateID: params.templateID,
			companyTemplate: params.companyTemplate,
			forTemplateType: params.forTemplateType,
			RodzajPrzychodu: params.RodzajPrzychodu,
			numberInvoice: params.numberInvoice,
			numeratorField: params.numeratorField,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function checkLicense(key) {
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "checkLicense",
			key
		})
	})
}

export function saveCostCenter(ID, MPK_CostTypes) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "saveCostCenter",
			mainCompanyID: ID,
			MPK_CostTypes: MPK_CostTypes,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function saveAccessMatrix({ companyID: COMPANY_ID, responsible: HUBLIDER, projectAssistant: ASSISTANT, processing: PROCESSING, confidential: RIGHT, mpkListData: MPK_LIST, verificationsInvoice, processingInvoice }) {
	let auth = updateAuth();
	for (let item of MPK_LIST) {
		delete item.key;
		delete item.innerKey;
	}
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "saveAccessMatrix",
			domain: auth.domain,
			auth: auth.token,
			COMPANY_ID,
			HUBLIDER,
			ASSISTANT,
			PROCESSING,
			RIGHT,
			MPK_LIST,
			processingInvoice,
			verificationsInvoice
		}
	})
}

export function saveRightsToInvoiceFunnel(rightsToInvoiceFunnel) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "saveRightsToInvoiceFunnel",
			domain: auth.domain,
			auth: auth.token,
			rightsToInvoiceFunnel
		}
	})
}

export function saveInvoicesSettings(params) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "saveinvoicessettings",
			vat: params.VAT,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function getCurrency({ code, date }) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: { method: 'Get currency', code, start_date: date, domain: auth.domain }
	})
}

export function findOCR(imgBase64, token, pdf) {
	let img = imgBase64.split(',')[1];
	var settings = {
		"url": `https://${ocr_url}/api/find?token=${token}`,
		"type": "POST",
		"timeout": 0,
		"headers": {
			"Content-Type": "application/json",
			"Cache-Control": "no-cache"
		},
		"data": JSON.stringify({ "img": img, "pdf": pdf })
	};
	return ajax(settings)
}

export function extractTableOCR(params) {
	let img = params.imgBase64.split(',')[1];

	var settings = {
		"url": `https://${ocr_url}/api/table/extract?token=${params.token}`,
		"type": "POST",
		"timeout": 0,
		"headers": {
			"Content-Type": "application/json",
			"Cache-Control": "no-cache"
		},
		"data": JSON.stringify({ "img": img, "bounds": params.bounds, "pdf": params.pdf })
	};
	return ajax(settings)
}
export function submitReportOCR(params) {
	let img = params.imgBase64.split(',')[1];

	var settings = {
		"url": `https://${ocr_url}/api/report?token=${params.token}`,
		"type": "POST",
		"timeout": 0,
		"headers": {
			"Content-Type": "application/json",
			"Cache-Control": "no-cache"
		},
		"data": JSON.stringify({
			"img": img,
			"pdf": params.pdf,
			"subject": params.subject,
			"report": params.report,
			"bounds": params.bounds,
			"table": params.table
		})
	};
	return ajax(settings)
}

export function Sort(part_data, sortData, filterData, dataType) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "sort",
			domain: auth.domain,
			auth: auth.token,
			part_data: part_data,
			dataType,
			sort_column: sortData.sort_column,
			sort_order: sortData.sort_order == "ascend" ? "ASC" : "DESC",
			filterParams: filterData
		}
	})
}

export function getFilter(fileType, searchParams) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: 'setfilter',
			domain: auth.domain,
			auth: auth.token,
			fileType,
			params: searchParams
		}
	})
}

export function getFilterInvoice(fileType, searchParams) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: 'setfilterInvoice',
			domain: auth.domain,
			auth: auth.token,
			fileType,
			params: searchParams
		}
	})
}

export function getFilterSales(fileType, searchParams) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: 'setfilterSales',
			domain: auth.domain,
			auth: auth.token,
			fileType,
			params: searchParams
		}
	})
}

export function getDocumentAllStage(flagFirstStage, fileID) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getdocumentallstage",
			domain: auth.domain,
			auth: auth.token,
			first_stage: flagFirstStage,
			id_file: fileID
		}
	})
}

export function getHistory(documentID) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "gethistory",
			domain: auth.domain,
			auth: auth.token,
			doc_id: documentID
		}
	})
}

export function getSalesHistory(documentID) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getSaleshistory",
			domain: auth.domain,
			auth: auth.token,
			doc_id: documentID
		}
	})
}

export function requestStep(data, url = url_req) {
	let auth = updateAuth();
	let lang = BX24.getLang();
	return ajax({
		type: "POST",
		url: url,
		data: Object.assign(data, {
			lang,
			domain: auth.domain,
			auth: auth.token
		})
	})
}

export function returnToNew(file_id) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "returnToNew",
			id: file_id,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function returnToDescription(file_id) {
	let auth = updateAuth();
	let lang = BX24.getLang();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "returnToDescription",
			lang,
			id: file_id,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function returnToStepBack(file_id, status) {
	let lang = BX24.getLang();
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "returnToStepBack",
			id: file_id,
			lang,
			status: status,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function confirmAccountCreation(file_id, params) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "confirmAccountCreation",
			id: file_id,
			domain: auth.domain,
			auth: auth.token,
			params
		}
	})
}

export function returnToStepBackSale(file_id, status) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "returnToStepBackSale",
			id: file_id,
			status: status,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function getSalesAllStage(flagFirstStage, fileID) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getsalesallstage",
			domain: auth.domain,
			auth: auth.token,
			first_stage: flagFirstStage,
			id_file: fileID
		}
	})
}

export function saveStep1onStep2(file_id) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "saveStep1onStep2",
			id: file_id,
			result_save: "success",
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function uploadFile(formData) {
	let auth = updateAuth();
	formData.append('domain', auth.domain);
	formData.append('auth', auth.token);
	return ajax({
		type: "POST",
		url: url_req,
		processData: false,
		contentType: false,
		data: formData,
	})
}

export function deletePage(fileID, currentPage) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "deletePage",
			fileID,
			currentPage,
			domain: auth.domain,
			auth: auth.token,
		},
	})
}

export function commentAdd(comments, element) {
	let auth = updateAuth();
	let data = {
		run: 'savecomment',
		comments: comments,
		domain: auth.domain,
		auth: auth.token,
	};
	if (element.mainid != undefined) {
		data = Object.assign(data, {
			docID: element.mainid,
			fileID: element.ID,
		})
	} else {
		data = Object.assign(data, element);
	}
	return ajax({
		type: "POST",
		url: url_req,
		data: data
	})
}

export function getPoglad(file_id) {
	let auth = updateAuth();
	// console.log(auth, 'auth');
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "poglad",
			id: file_id,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function getDataSettings() {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getDataSettings",
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function getAllCreatingInvoice() {
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "getAllCreatingInvoice",
		})
	})
}

export function saveDefaultResponsible({ verification = '', processing = '' }) {
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "saveDefaultResponsible",
			verification, processing
		})
	})
}

export function saveRightsFVSResponsible(params) {
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "saveRightsFVSResponsible",
			params
		})
	})
}


export function deleteFile(mainID, fileID) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "fileDelete",
			mainID, fileID,
			domain: auth.domain,
			auth: auth.token,
		},
	});
}

export function saveReports(reportsType, reportOptions) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "saveReports",
			reportsType,
			reportOptions,
			domain: auth.domain,
			auth: auth.token,
		},
	});
}


export function getInvoiceCorrection({ type, current_id, my_company, kontragent }) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getInvoiceCorrection",
			type,
			current_id,
			my_company,
			kontragent,
			domain: auth.domain,
			auth: auth.token,
		},
	});
}
export function getMediaListSort(sort) {
	let auth = updateAuth();
	return ajax({
		type: "GET",
		url: url_req,
		data: {
			run: "getMediaListSort",
			sort,
			domain: auth.domain,
			auth: auth.token
		}
	})
}
export function getMediaListForecastsSort(sort) {
	let auth = updateAuth();
	return ajax({
		type: "GET",
		url: url_req,
		data: {
			run: "getMediaListForecastsSort",
			sort,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function getReportGroupMediaListSort(sort) {
	let auth = updateAuth();
	return ajax({
		type: "GET",
		url: url_req,
		data: {
			run: "getReportGroupMediaListSort",
			sort,
			domain: auth.domain,
			auth: auth.token
		}
	})
}
export function getMediaListDateUsers() {
	let auth = updateAuth();
	return ajax({
		type: "GET",
		url: url_req,
		data: {
			run: "getMediaListDateUsers",
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function postMediaListItem(project, data) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "postMediaListItem",
			project,
			data,
			domain: auth.domain,
			auth: auth.token
		}
	})
}
export function postEditMediaListItem(project) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "postEditMediaListItem",
			project,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function postEditPerformed(project) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "postEditPerformed",
			project,
			domain: auth.domain,
			auth: auth.token
		}
	})
}

export function getInvoiceSalesCorrection({ type, current_id, my_company, kontragent, invoiceID }) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "getInvoiceSalesCorrection",
			type,
			current_id,
			my_company,
			kontragent,
			invoiceID,
			domain: auth.domain,
			auth: auth.token,
		},
	});
}

export function sendExportReport(params) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "sendExportReport",
			params,
			domain: auth.domain,
			auth: auth.token,
		},
	});
}

export function filterIncomeStatement({ Deals = [], Contractors = [], mainCompanies = [], Dates = [], Categories = [] }) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "filterIncomeStatement",
			Deals,
			Contractors,
			mainCompanies,
			Categories,
			Dates,
			domain: auth.domain,
			auth: auth.token,
		},
	});
}

export function deleteExportReport(fileID) {
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "deleteExportReport",
			fileID,
		})
	})
}

export function getExportTable() {
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "getExportTable"
		})
	})
}

export function getExportTableExpandRow(fileID) {
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "getExportTableExpandRow",
			fileID
		})
	})
}

export function getReports() {
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "getReports",
		})
	})
}

export function getEmailTemplates() {
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "getEmailTemplates"
		})
	})
}

export function saveEmailTemplate(editForm) {
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "saveEmailTemplate",
			editForm,
		})
	})
}

export function deleteEmailTemplate(ID) {
	return fetch(url_req, {
		method: "POST",
		body: FetchBody({
			run: "deleteEmailTemplate",
			ID,
		})
	})
}

export function addBudget(deal) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "addBudget",
			domain: auth.domain,
			auth: auth.token,
			deal
		},
	});
}

export function addPosition(position) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "addPosition",
			domain: auth.domain,
			auth: auth.token,
			position
		},
	});
}
export function removePosition(idPosition, idBudget) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "removePosition",
			domain: auth.domain,
			auth: auth.token,
			idPosition,
			idBudget
		},
	});
}
export function editPosition(position) {
	let auth = updateAuth();
	return ajax({
		type: "POST",
		url: url_req,
		data: {
			run: "editPosition",
			domain: auth.domain,
			auth: auth.token,
			position
		},
	});
}

export function raportBudget(raportBudget) {
	let auth = updateAuth();
	return ajax({
		type: "GET",
		url: url_req,
		data: {
			run: "raportBudget",
			domain: auth.domain,
			auth: auth.token,
			raportBudget
		},
	});
}

export function getFilterBudget(filter) {
	let auth = updateAuth();
	return ajax({
		type: "GET",
		url: url_req,
		data: {
			run: "getFilterBudget",
			domain: auth.domain,
			auth: auth.token,
			filter
		},
	});
}

export function getBudget(filter) {
	let nameBudget = undefined;
	let deal = undefined;
	let BudgetID = undefined;
	let categories = undefined;
	// console.log(filter);
	if (filter) {
		BudgetID = filter?.idBudget;
		deal = filter?.idDeal;
		categories = filter?.categories;
	}
	let auth = updateAuth();
	return ajax({
		type: "GET",
		url: url_req,
		data: {
			run: "getBudget",
			domain: auth.domain,
			auth: auth.token,
			nameBudget,
			deal,
			BudgetID,
			categories
		},
	});
}

export function getCategories() {
	let auth = updateAuth();
	return ajax({
		type: "GET",
		url: url_req,
		data: {
			run: "getCategories",
			domain: auth.domain,
			auth: auth.token
		},
	});
}

export function getPosition(idBudget) {
	let auth = updateAuth();
	return ajax({
		type: "GET",
		url: url_req,
		data: {
			run: "getPosition",
			domain: auth.domain,
			auth: auth.token,
			idBudget
		},
	});
}

export function removeBudget(idBudget) {
	let auth = updateAuth();
	return ajax({
		type: "GET",
		url: url_req,
		data: {
			run: "removeBudget",
			domain: auth.domain,
			auth: auth.token,
			idBudget
		},
	});
}


export function testBudget() {
	let auth = updateAuth();
	return ajax({
		type: "GET",
		url: url_req,
		data: {
			run: "testing",
			domain: auth.domain,
			auth: auth.token,
		},
	});
}
